<template>
<div class="funtask-app-enable">
  <h3>API用法</h3>
  <funtask-code>
    import funtask from "@suwis/funtask"
    let apps = await funtask.getApps();
    funtask.app.enable(app[0].package)
  </funtask-code>
  <br>
  <h3>点击尝试启用以下应用</h3>
  <div>
    <mu-button class="btn"
      color="primary"
      flat
      @click="enable(app)"
      v-for="app in apps"
      v-show="app.disabled"
      :key="app.name">{{app.name}}</mu-button>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      config: {},
      apps: []
    }
  },
  mounted() {
    this.getApps()
  },
  methods: {
    async enable(app) {
      await this.$funtask.app.enable(app.package)
      await this.getApps()
    },
    async getApps() {
      this.apps = await this.$funtask.app.getApps()
    }
  }
}
</script>
<style lang="scss">
.funtask-app-enable {
    position: relative;

    h3 {
        display: flex;
        align-items: center;

        .btn {
            margin-left: 5vw;
        }
    }
}
</style>
